import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { useSWR } from 'modules/network/hooks/useSwr'
import { PoolAsset } from '../constants/poolAssets'
import { PoolRisk } from '../constants/PoolRisk'
import { getPoolInvestorByAssetAndRisk } from '../utils/getPoolInvestorContract'
import { getPoolProjectedApy } from '../utils/getPoolProjectedApy'

type Args = {
  risk: PoolRisk | '' | null | undefined
  asset: PoolAsset | '' | null | undefined
}

export const usePoolProjectedApy = ({ risk, asset }: Args) => {
  const { chainId, library } = useWeb3()

  const data = useSWR(
    risk && asset ? `${asset}-${risk}-apy` : null,
    async () => {
      if (!risk || !asset) return

      const { contract } = getPoolInvestorByAssetAndRisk(asset, risk)
      const poolInvestor = contract.connectWeb3({ chainId, library })

      return getPoolProjectedApy({ chainId, poolInvestor })
    },
  )

  return data
}
